import React, { useState, type ChangeEvent, type FocusEvent } from "react";
import type { FieldError } from "react-hook-form";
import "./PasswordInput.scss";
import { IconButton, TextInput } from "@SeemplicityDev/shared";

interface PasswordInputProps {
  value?: string;
  label?: string;
  required?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  error?: FieldError;
  isLarge?: boolean;
  dataTestId?: string;
  placeholder?: string;
  disabled?: boolean;
  autoComplete?: string;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  value,
  label,
  required,
  onChange = () => {},
  onBlur = () => {},
  error,
  isLarge,
  dataTestId,
  placeholder = "Type...",
  disabled,
  autoComplete = "",
}) => {
  const [show, setShow] = useState(false);

  const getSuffixBtn = () => {
    const icon = value ? (show ? "seem-icon-hide" : "seem-icon-eye") : "";
    return (
      <IconButton
        className={`input-suffix-btn-${icon}`}
        isIcon={icon}
        onClick={() => setShow(!show)}
        type="button"
        data-testid={`input-suffix-btn-${icon}`}
      />
    );
  };

  return (
    <TextInput
      label={label}
      required={required}
      data-testid={dataTestId}
      wrapperClassName={"input-wrap-password"}
      suffixIconButton={getSuffixBtn()}
      type={show ? "text" : "password"}
      value={value}
      onChange={onChange}
      // Shared TextInput types onBlur as `() => void` but forwards the focus event at runtime; cast preserves the event-aware handler.
      onBlur={onBlur as () => void}
      error={error}
      placeholder={placeholder}
      isLarge={isLarge}
      disabled={disabled}
      autoComplete={autoComplete}
    />
  );
};

export default PasswordInput;
